import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { useTheme } from '../../../../../../../theming/useTheme';
import { VrLineHeight } from '../../../../../../../theming/verticalRhythm/verticalRhythm';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../../../../../partials/link/TextLink';
import { MEDIA_BREAKPOINTS } from '../../../../../../../mediaQueries.const';

const componentConfigThemeKey = 'menuSubLink';

export interface MenuSubLinkDataProps {
  href: string,
  text: string,
}

interface MenuSubLinkThemeProps {
  vrLineHeight: VrLineHeight
  idleColor: string,
}

const getMenuSubLinkStyle = (vrLineHeight: VrLineHeight) => StyleSheet.create({
  style: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      margin: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px ${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px 0 ${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 1.5}px`,
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      margin: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px ${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px 0 ${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 1.5}px`,
    },
  },
});

export const MenuSubLinkComponent: React.FunctionComponent<MenuSubLinkThemeProps & MenuSubLinkDataProps> = props => {
  const { href, text, idleColor, vrLineHeight } = props;
  const linkStyle = generateLinkStyleFromTheme({ idleColor });
  const style = getMenuSubLinkStyle(vrLineHeight);
  return (
    <li className={css(style.style)}>
      <TextLinkComponent href={href} linkStyle={linkStyle}>
        <p>{text}</p>
      </TextLinkComponent>
    </li>
  );
};

const mapThemeProps = (theme: MenuSubLinkThemeProps) => {
  return {
    vrLineHeight: theme.vrLineHeight,
    idleColor: theme.idleColor,
  };
};

export const MenuSubLink = (props: MenuSubLinkDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <MenuSubLinkComponent {...themeContext} {...props} />;
};
